import { FC } from 'react';
import UserIcon from 'src/icons/UserIcon';
import IconButton, {
  VariantBg
} from 'src/shared-components/design-system/IconButton/IconButton';

interface ButtonComponentProps {
  clientInfo;
  darkStyle?: boolean;
  userToken: string;
  isHideMenu: boolean;
}

const ButtonComponent: FC<ButtonComponentProps> = ({
  clientInfo,
  darkStyle,
  userToken,
  isHideMenu
}) => {
  if (userToken && isHideMenu) {
    const getInitials = (name = '', surname = '') => {
      return {
        firstNameInitial: name ? name.charAt(0).toUpperCase() : '',
        lastNameInitial: surname ? surname.charAt(0).toUpperCase() : ''
      };
    };

    const userNameInitials = getInitials(clientInfo?.name, clientInfo?.surname);

    return (
      <div>
        <div className="flex fs-body-bold uppercase text-dark justify-center items-center align-center w-8 h-8 rounded-full shadow bg-gallery gap-px">
          <span>{userNameInitials?.firstNameInitial}</span>
          <span>{userNameInitials?.lastNameInitial}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center">
      <IconButton
        icon={{
          alt: 'cart icon',
          component: UserIcon
        }}
        isBg={false}
        variantBg={darkStyle ? VariantBg.DARK : VariantBg.LIGHT}
      />
    </div>
  );
};

export default ButtonComponent;
